import { render, staticRenderFns } from "./_travel-list-item.vue?vue&type=template&id=238dc2ae"
import script from "./_travel-list-item.vue?vue&type=script&lang=js"
export * from "./_travel-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports